import { render, staticRenderFns } from "./admin-layout.vue?vue&type=template&id=4c8ec5d0&scoped=true"
import script from "./admin-layout.vue?vue&type=script&lang=js"
export * from "./admin-layout.vue?vue&type=script&lang=js"
import style0 from "./admin-layout.vue?vue&type=style&index=0&id=4c8ec5d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8ec5d0",
  null
  
)

export default component.exports